import { createAction, props } from '@ngrx/store';

export const upsertWheelReminder = createAction(
  '[Wheel Reminder] Upsert',
  props<{ wheelId: string; reminder: UpsertWheelReminderDto; isUpdate: boolean }>()
);
export const upsertWheelReminderSuccess = createAction(
  '[Wheel Reminder] Upsert Success',
  props<{ wheelId: string; reminder: WheelReminderOutputDto; isUpdate: boolean }>()
);
export const upsertWheelReminderFailure = createAction('[Wheel Reminder] Upsert Failure', props<{ error: string }>());

export const disableWheelReminder = createAction('[Wheel Reminder] Disable', props<{ wheelId: string }>());
export const disableWheelReminderSuccess = createAction('[Wheel Reminder] Disable Success', props<{ wheelId: string }>());
export const disableWheelReminderFailure = createAction('[Wheel Reminder] Disable Failure', props<{ error: string }>());
